
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { StateHandler } from "../../../dev/utils/StateHandler";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { GameData, BaseModel } from '../../server/data/BaseModel';
import { WinGameData } from "../../server/data/GameDataModels";
import { RoadRage } from "../../RoadRage";
import { GameConfig } from "../../config/base/GameConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { RoadRageSpriteSymbol } from "../../reel/symbol/RoadRageSpriteSymbol";
import { GameSetting } from "../../../dev/setting/GameSetting";
import { SoundManager } from "../../config/sound/SoundManager";
import { SoundConfig } from "../../config/sound/SoundConfig";
import { IBetWayWinData } from "../../server/data/IData";
import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';

class WinState extends StateHandler {
    public static readonly WIN: string = "win";
    public static readonly SMALL_WIN: string = "small_win";
    public static readonly NORMAL: string = "normal";
    public static readonly BIGWIN: string = "bigwin";
    public static readonly DONE: string = "done";
}

export class NormalWinPresentation extends Presentation {

    private winData: WinGameData;
    private _winState: WinState = new WinState();

    private winAmount: number = 0;

    private bigWin: boolean = false;
    private winIndx: number = 0;

    private winConfigDurr: number = 0;
    private lastNormalIndex: number = 0;

    private noWinAlpha: number = 0.45;
    private skipped: boolean = false;
    private skipFunc: Function;

    private isBelowStake:boolean = false;
    private isIndvBelowStake:boolean = false;
    private isTotalWin:boolean = false;

    public checkForActivation(data: GameData): boolean { return !!data.Win.singleWin; }

    public initialization(): void {
        this.lastNormalIndex = GameConfig.instance.WIN_RATIOS.normalWin.length - 1;
    }

    preStart(): void {
        this.skipped = false;
    }

    public setGamedData(data: GameData): void {
        this.winData = data.Win;

        this.bigWin = this.winData.isBigWin;
        this._winState.set(WinState.WIN);

        this.isTotalWin = data.mode !== GameMode.NORMAL && this.winData!.totalWin != this.winData.singleWin;

        this.winAmount = !this.bigWin ? this.winData.singleWin : this.winData.playedBetValue * GameConfig.instance.WIN_RATIOS.bigWin[0].ratio;

        this.winIndx = GameConfig.instance.WIN_RATIOS.normalWin.findIndex((indx) => indx.ratio == this.winData.winRatioConfig.ratio);
        if (this.winIndx == -1) this.winIndx = this.lastNormalIndex;
        
        this.winConfigDurr = GameConfig.instance.WIN_RATIOS.normalWin[this.winIndx].duration;
        this.isIndvBelowStake = data.Win.isIndiviWinBelowStake();
        this.isBelowStake = data.Win.isWinBelowStake!();
    }

    createPresentation(skip: Function): void {
        this.skipFunc = skip;

        switch (this._winState.value) {
            case WinState.WIN:
                this.skipFunc(!this.bigWin);
                this.winPositions();
                this._winState.set(this.bigWin ? WinState.DONE : WinState.NORMAL);
                if(this.isIndvBelowStake)
                    this._winState.set(WinState.DONE);
                break;
            case WinState.NORMAL:
                this.skipFunc(!this.bigWin);
                this.addWinCountUpToTimeline();
                this._winState.set(WinState.DONE);
                break;
            default:
                if (!this.bigWin) this.timeline.to(this, { duration: 0.15 });
                this.PresentationState.setInactive();
                break;
        }
    }

    protected winPositions(): void {

        const perRow: number = GameSetting.isFastSpin ? 0.135 : 0.18;
        const animationDurr: number = 0.5;
        

        const winGrps: IBetWayWinData[] = this.winData.normalWinData!;

        if(this.isIndvBelowStake){}
        else if (winGrps.length == 1) return;

        let startPos: number = 0;
        for (let groups = 0; groups < winGrps.length; groups++) {
            const winData: IBetWayWinData = winGrps[groups];
            let triggerValue:boolean = RoadRage.apiPlugin.gameClientConfiguration.displayIndividualWinsInGame;

            for (let reel = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];
                for (let row = 0; row < posRow.length; row++) {
                    const sym: RoadRageSpriteSymbol | undefined = RoadRageEngineManager.getReel(reel).getSymbol(row);
                    if (sym) {
                        this.timeline.add(() => sym.markNonWin(!posRow[row], this.noWinAlpha, animationDurr/2), startPos);
                        this.timeline.add(() => sym.glowPreHit(posRow[row], animationDurr, winData.winLvl), startPos);
                        if(triggerValue && reel == winData.length-1 && posRow[row]){
                            this.timeline.add(() => sym.hintValue(winData.amount,winData.numberOfCombinations), startPos);
                            triggerValue = false;
                        }
                    }
                }
            }
            this.timeline.add(() => {if(!this.isIndvBelowStake) SoundManager.playSoundEffect(SoundConfig.WIN_HIGHLIGHT)},startPos);
            startPos += animationDurr / 1.75;
        }

        if(this.bigWin){
            this.timeline.add(() => this.removeSymFrames(0.5,true),startPos+0.1);
            for (let reel = 0; reel < this.winData.allBetWayWinData.reelWinPositions.length; reel++) {
                for (let row = 0; row < this.winData.allBetWayWinData.reelWinPositions[reel].length; row++) {
                    const sym: RoadRageSpriteSymbol | undefined = RoadRageEngineManager.getReel(reel).getSymbol(row);
                    if (sym) {
                        const hits: boolean = this.winData.allBetWayWinData.reelWinPositions[reel][row];
                        if(hits) this.timeline.add(() => sym.markNonWin(!hits, this.noWinAlpha, 0.5), startPos+0.1);
                    }
                }
            }
            
        }
        this.timeline.to(this, { duration:  animationDurr / (this.bigWin ? 1.75 :  1.5) })
        // this.timeline.to(this, { duration:  animationDurr / 1.5 })
    }

    protected addWinCountUpToTimeline(): void {

        let countUpDuration: number = this.winConfigDurr;
        let animDurr: number = countUpDuration ? 0.5 : 0.3;

        const splittedDurr = countUpDuration / this.winData.allBetWayWinData.longest;// - (animDurr / this.winData.allBetWayWinData.longest)/2;

        let startPos: number = 0;
        let waysDelay: number = countUpDuration ?  0.2 :  0;
        const perReel: number = countUpDuration ? GameSetting.isFastSpin ? splittedDurr * 0.7 : splittedDurr : 0;

        if(countUpDuration){
            for (let reel = 0; reel < this.winData.allBetWayWinData.reelWinPositions.length; reel++) {
                for (let row = 0; row < this.winData.allBetWayWinData.reelWinPositions[reel].length; row++) {
                    const sym: RoadRageSpriteSymbol | undefined = RoadRageEngineManager.getReel(reel).getSymbol(row);
                    if (sym) {
                        const hits: boolean = this.winData.allBetWayWinData.reelWinPositions[reel][row];
                        this.timeline.add(() => sym.playWin(hits, animDurr, this.winData.allBetWayWinData.biggestWinLvl), startPos);
                    }
                }
                if (reel < this.winData.allBetWayWinData.longest)
                    startPos += perReel;
            }
        }

        for (let reel = 0; reel < this.winData.allBetWayWinData.reelWinPositions.length; reel++) {
            for (let row = 0; row < this.winData.allBetWayWinData.reelWinPositions[reel].length; row++) {
                const sym: RoadRageSpriteSymbol | undefined = RoadRageEngineManager.getReel(reel).getSymbol(row);
                if (sym) {
                    const hits: boolean = this.winData.allBetWayWinData.reelWinPositions[reel][row];
                    this.timeline.add(() => {
                        sym.glowPreHit(hits, animDurr, this.winIndx)
                        if(!hits) sym.setNonAlpha(this.noWinAlpha);
                    }, startPos);
                    this.timeline.add(() => sym.markNonWin(!hits, this.noWinAlpha, animDurr), startPos+animDurr/2);
                }
            }
        }

        this.timeline.add(() => {
            SoundManager.playSoundEffect(SoundConfig.WIN_SOUNDS[this.winIndx]);
            RoadRage.counter.play(0, this.winAmount, countUpDuration, this.winData.totalWinCombination);
        }, 0);

        this.timeline.add(() => {
            RoadRage.counter.bounceHit(this.winIndx);
            if(this.winIndx > 1)
                RoadRage.particleManager.triggerWinSplash(false);

        }, countUpDuration);

        
        this.timeline.add(() => {
            RoadRage.counter.showWays(countUpDuration ? countUpDuration : animDurr / 4);
        }, countUpDuration + waysDelay);

        // Reset and remove blackness.
        if(countUpDuration)
            this.timeline.to(this, { duration: animDurr + countUpDuration + waysDelay + this.winIndx > 2 ? 0.5 : 0 }, 0);
    }

    public skip(): void {
        if (this._winState.equal(WinState.DONE)) this.skipped = true;
        super.skip();
    }

    public done(): void {
        if (!this.bigWin) {
            SlotGame.keypadPlugin.setWin(this.winData!.totalWin, this.isTotalWin, this.isBelowStake);
            if (this.skipped)
                RoadRage.counter.stop(this.winAmount, 0.25, 0.25).add(() => this.removeSymFrames(0.25), 0.25);
            else
                RoadRage.counter.stop(this.winAmount, 0.5, 1).add(() => this.removeSymFrames(1), 1);
        } else {
            // this.removeSymFrames(0);
        }

    }

    private removeSymFrames(duration: number,ignoreDarknessChange?:boolean): void {
        RoadRageEngineManager.RSAll((rc, sym) => {
            sym.stopWin(duration,ignoreDarknessChange);
        })
    }
}